<sw-page class="topdata-llm-connect-llm-assignment-list-page">
    <template #search-bar>
        <sw-search-bar :initial-search-type="'tdlc_llm_assignment'"
                       :placeholder="$tc('TopdataLlmConnectSW6.assignment.searchBarPlaceholder')">
        </sw-search-bar>
    </template>

    <template #smart-bar-header>
        <h2>{{ $tc('TopdataLlmConnectSW6.assignment.listTitle') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onAddAssignment">
            {{ $tc('TopdataLlmConnectSW6.assignment.addButton') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-llm-connect-llm-assignment"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="false"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-active="{ item }">
                <sw-label v-if="item.active" variant="success" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.assignment.activeYes') }}
                </sw-label>
                <sw-label v-else variant="danger" size="medium">
                    {{ $tc('TopdataLlmConnectSW6.assignment.activeNo') }}
                </sw-label>
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditAssignment(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <topdata-llm-connect-llm-assignment-form
            v-if="isFormInitialized"
            :entity="currentEntity"
            :repository="repository"
            :show-modal="activeModal"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />
    </template>
</sw-page>